import * as Yup from "yup";

export const table = {
  primaryData: [
    {
      title: "Name",
      value: "global_name",
      type: "configue",
    },
    {
      title: "Sbd Subject Id",
      value: "sbd_subject_id",
      type: "configue",
    },
    {
      title: "Status",
      value: "status",
    },
    {
      title: "CreatedBy",
      value: "created_by_name",
      type: "configue",
    },
    {
      title: "CreatedAt",
      value: "created_at",
      type: "configue",
    },
    {
      title: "Actions",
      width: "5%",
      sendStatus: true,
    },
  ],
  secondaryData: [],
};

export type subject = {
  global_name: string;
  gcf_public_subject_id: string;
  status: string;
  subject_code: string;
  image_url: string;
  tags: string;
  synonyms: string;
  sbd_subject_id: string;
  assets: string;
  gcf_public_subject_name: string;
  npractice_public_subject_id: string;
  npractice_public_subject_name: string;
  npractice_practice_subject_id: string;
  npractice_practice_subject_name: string;
  nexam_public_subject_id: string;
  nexam_public_subject_name: string;
};

export const subjectInitialValues: subject = {
  global_name: "",
  gcf_public_subject_id: "",
  status: "ACTIVE",
  subject_code: "",
  image_url: "",
  tags: "",
  synonyms: "",
  sbd_subject_id: "",
  assets: "",
  gcf_public_subject_name: "",
  npractice_public_subject_id: "",
  npractice_public_subject_name: "",
  npractice_practice_subject_id: "",
  npractice_practice_subject_name: "",
  nexam_public_subject_id: "",
  nexam_public_subject_name: "",
};

export const subjectMandatoryFields = [{ id: "global_name" }];

export const subjectValidationSchema = Yup.object().shape({
  global_name: Yup.string().required("Name is required"),
});

export const subjectProperties = [
  {
    id: "global_name",
    type: "text",
    label: `Name`,
    className: "name-styles",
    breakpoints: { xs: 12, sm: 6, md: 6, lg: 3 },
    required: true,
  },
  {
    id: "subject_code",
    type: "text",
    label: `Subject code`,
    className: "name-styles",
    breakpoints: { xs: 12, sm: 6, md: 6, lg: 3 },
    required: false,
  },
  {
    id: "image_url",
    type: "url-file-upload",
    label: "Image Url",
    className: "select-styles",
    breakpoints: { xs: 12, sm: 6, md: 4, lg: 3 },
    required: false,
    size: 10,
    feature: "global-content-hierarchy",
    fileType: [".jpg", ".png"],
    acceptTypes: "image/*",
  },
  {
    id: "synonyms",
    type: "text",
    label: `Synonyms`,
    className: "name-styles",
    breakpoints: { xs: 12, sm: 6, md: 6, lg: 3 },
    required: false,
  },
  {
    id: "sbd_subject_id",
    type: "text",
    label: `Sbd subject id`,
    className: "name-styles",
    breakpoints: { xs: 12, sm: 6, md: 6, lg: 3 },
    required: false,
  },
  {
    id: "status",
    type: "normal-select",
    label: "Status",
    className: "select-styles",
    breakpoints: { xs: 12, sm: 6, md: 3, lg: 3 },
    options: [
      { label: "Active", value: "ACTIVE" },
      { label: "InActive", value: "INACTIVE" },
      { label: "Deleted", value: "DELETED" },
    ],
    hideNone: true,
  },
];

export const subjectPropertiesUpdate = [
  {
    id: "global_name",
    type: "text",
    label: `Name`,
    className: "name-styles",
    breakpoints: { xs: 12, sm: 6, md: 6, lg: 3 },
    required: true,
  },
  {
    id: "subject_code",
    type: "text",
    label: `Subject code`,
    className: "name-styles",
    breakpoints: { xs: 12, sm: 6, md: 6, lg: 3 },
    required: false,
  },
  {
    id: "image_url",
    type: "url-file-upload",
    label: "Image Url",
    className: "select-styles",
    breakpoints: { xs: 12, sm: 6, md: 4, lg: 3 },
    required: false,
    size: 10,
    feature: "global-content-hierarchy",
    fileType: [".jpg", ".png"],
    acceptTypes: "image/*",
  },
  {
    id: "tags",
    type: "text",
    label: `Tags`,
    className: "name-styles",
    breakpoints: { xs: 12, sm: 6, md: 6, lg: 3 },
    required: false,
  },
  {
    id: "synonyms",
    type: "text",
    label: `Synonyms`,
    className: "name-styles",
    breakpoints: { xs: 12, sm: 6, md: 6, lg: 3 },
    required: false,
  },
  {
    id: "sbd_subject_id",
    type: "text",
    label: `Sbd subject id`,
    className: "name-styles",
    breakpoints: { xs: 12, sm: 6, md: 6, lg: 3 },
    required: false,
  },
  {
    id: "assets",
    type: "text",
    label: `Assets`,
    className: "name-styles",
    breakpoints: { xs: 12, sm: 6, md: 6, lg: 3 },
    required: false,
  },
  {
    id: "status",
    type: "normal-select",
    label: "Status",
    className: "select-styles",
    breakpoints: { xs: 12, sm: 6, md: 3, lg: 3 },
    options: [
      { label: "Active", value: "ACTIVE" },
      { label: "InActive", value: "INACTIVE" },
      { label: "Deleted", value: "DELETED" },
    ],
    hideNone: true,
  },
  {
    id: "gcf_public_subject_id",
    type: "text",
    label: `Gcf Public Subject id`,
    className: "name-styles",
    breakpoints: { xs: 12, sm: 6, md: 6, lg: 3 },
    required: false,
  },
  {
    id: "gcf_public_subject_name",
    type: "text",
    label: `Gcf Public Subject Name`,
    className: "name-styles",
    breakpoints: { xs: 12, sm: 6, md: 6, lg: 3 },
    required: false,
  },
  {
    id: "npractice_public_subject_id",
    type: "text",
    label: `nPractice public subject id`,
    className: "name-styles",
    breakpoints: { xs: 12, sm: 6, md: 6, lg: 3 },
    required: false,
  },
  {
    id: "npractice_public_subject_name",
    type: "text",
    label: `nPractice public subject name`,
    className: "name-styles",
    breakpoints: { xs: 12, sm: 6, md: 6, lg: 3 },
    required: false,
  },
  {
    id: "npractice_practice_subject_id",
    type: "text",
    label: `nPractice practice subject id`,
    className: "name-styles",
    breakpoints: { xs: 12, sm: 6, md: 6, lg: 3 },
    required: false,
  },
  {
    id: "npractice_practice_subject_name",
    type: "text",
    label: `nPractice practice subject name`,
    className: "name-styles",
    breakpoints: { xs: 12, sm: 6, md: 6, lg: 3 },
    required: false,
  },
  {
    id: "nexam_public_subject_id",
    type: "text",
    label: `nExam public subject id`,
    className: "name-styles",
    breakpoints: { xs: 12, sm: 6, md: 6, lg: 3 },
    required: false,
  },
  {
    id: "nexam_public_subject_name",
    type: "text",
    label: `nExam public subject name`,
    className: "name-styles",
    breakpoints: { xs: 12, sm: 6, md: 6, lg: 3 },
    required: false,
  },
];

export const subjectUpdateProperties = [
  {
    id: "global_name",
    type: "text",
    label: `Name`,
    className: "name-styles",
    breakpoints: { xs: 12, sm: 6, md: 6, lg: 3 },
    required: true,
  },
];
